<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <v-main>
      <router-view class="pa-2" @authenticated="setAuthenticated" />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Layout from './Layout.vue';
import axios from 'axios';
// import carnego_theme from '@/plugins/vuetify';
import { carnego_theme } from '@/plugins/vuetify';

import { ICarnegoUser } from '../main';

@Component({
  components: {},
})
export default class LoginLayout extends Layout {

  public drawer: any = false;

  public created() {
    this.theme = carnego_theme;
  }

  public closeDrawer(): void {
    this.drawer = false;
  }
}
</script>

<style lang="less">
</style>
